module.exports = __webpack_public_path__ + "static/media/retail-property-catering-hero.3e0f7f7e.jpg";